var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.617,
    height: 15,
    viewBox: "0 0 13.617 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(-2.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2701",
    "data-name": "Group 2701",
    transform: "translate(2.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    d: "M1.12-.85H10.8a1.972,1.972,0,0,1,1.97,1.97V5.959a1.972,1.972,0,0,1-1.97,1.97H1.12A1.972,1.972,0,0,1-.85,5.959V1.12A1.972,1.972,0,0,1,1.12-.85Zm9.677,7.6a.8.8,0,0,0,.795-.795V1.12A.8.8,0,0,0,10.8.325H1.12a.8.8,0,0,0-.795.795V5.959a.8.8,0,0,0,.795.795Z",
    transform: "translate(0.85 7.071)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M13.65,8.546a.588.588,0,0,1-.588-.588V5.194a2.869,2.869,0,0,0-5.737,0V7.959a.588.588,0,0,1-1.175,0V5.194a4.044,4.044,0,0,1,8.088,0V7.959A.588.588,0,0,1,13.65,8.546Z",
    transform: "translate(-3.385 -1.15)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.230117a691801ec14c446fcfcec9a084.svg";
export { ForwardRef as ReactComponent };